import { View, Text, Image, TouchableOpacity, CheckBox } from "react-native";
import React, { useState } from "react";
import { AppColors } from "../../utility/AppColors";
import { CreateResponsiveStyle } from "rn-responsive-styles";
import { AppImages } from "../../utility/AppImages";

const PaymentOptions = () => {
  const styles = useStyles();

  const [selectedOption, setSelectedOption] = useState(null);
  const [cardCount, setCardCount] = useState(1); // State to track number of added cards

  const handleSelectOption = (option) => {
    setSelectedOption(option);
  };

  const addNewCard = () => {
    setCardCount(cardCount + 1); // Increment card count to add a new box
  };

  return (
    <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 20 }}>
      <TouchableOpacity
        style={[
          styles.optionContainer,
          {
            backgroundColor:
              selectedOption === "PayPal"
                ? AppColors.gray_C3C3C3
                : AppColors.gray_1E1E1E,
          },
        ]}
        onPress={() => handleSelectOption("PayPal")}
      >
        <Image source={AppImages.icPayPal} style={styles.optionImage} />
        <CheckBox
          value={selectedOption === "PayPal"}
          onValueChange={() => handleSelectOption("PayPal")}
          style={styles.checkBox}
        />
      </TouchableOpacity>

      <TouchableOpacity
        style={[
          styles.optionContainer,
          {
            backgroundColor:
              selectedOption === "Card"
                ? AppColors.gray_C3C3C3
                : AppColors.gray_1E1E1E,
          },
        ]}
        onPress={() => handleSelectOption("Card")}
      >
        <Image source={AppImages.icVisa} style={styles.optionImage} />
        <CheckBox
          value={selectedOption === "Card"}
          onValueChange={() => handleSelectOption("Card")}
          style={styles.checkBox}
        />
      </TouchableOpacity>

      {Array.from({ length: cardCount }).map((_, index) => (
        <TouchableOpacity
          key={index}
          style={[
            styles.optionContainer,
            {
              backgroundColor: AppColors.gray_1E1E1E,
            },
          ]}
          onPress={() => handleSelectOption(`Card${index}`)}
        >
          <View style={styles.addCardContainer}>
            <Text style={styles.addCardText}>Card {index + 1}</Text>
          </View>
          <CheckBox
            value={selectedOption === `Card${index}`}
            onValueChange={() => handleSelectOption(`Card${index}`)}
            style={styles.checkBox}
          />
        </TouchableOpacity>
      ))}

      <TouchableOpacity
        style={[styles.optionContainer, styles.addCardButton]}
        onPress={addNewCard} // Add a new card when this is pressed
      >
        <View style={styles.addCardContainer}>
          <Image source={AppImages.icPlusIcon} style={styles.plusImg} />
        </View>
      </TouchableOpacity>
    </View>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    optionContainer: {
      width: 242,
      height: 158,
      borderRadius: 8,
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
    },
    optionImage: {
      width: "80%",
      height: "60%",
      resizeMode: "contain",
    },
    plusImg: {
      width: 51,
      height: 51,
      resizeMode: "contain",
    },
    checkBox: {
      position: "absolute",
      top: 10,
      right: 10,
      borderRadius: 50, // Make the checkbox round
    },
    addCardContainer: {
      justifyContent: "center",
      alignItems: "center",
      //   backgroundColor: AppColors.black_121212,
      width: "100%",
      height: "100%",
    },
    addCardText: {
      fontSize: 40,
      color: AppColors.white,
    },
    addCardButton: {
      backgroundColor: AppColors.gray_5B5B5B,
    },
  },
  {}
);

export default PaymentOptions;
